export const getInitials = (name: string): string => {
  const getFirstLetterOfWord = (word: string | undefined): string => {
    return typeof word !== 'undefined' ? word[0] : ''
  }

  const words: string[] = name.split(' ')
  const firstWord = words.shift()
  const lastWord = words.pop()
  return [getFirstLetterOfWord(firstWord), getFirstLetterOfWord(lastWord)].join('').toUpperCase()
}

export const isUndefinedOrEmpty = (input?: string | null): boolean => {
  return (input ?? '').trim().length === 0
}

export const getCountryEmoji = (countryCode: string): string => {
  if (typeof countryCode !== 'string') {
    return ''
  }
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0))
  return String.fromCodePoint(...codePoints)
}

export const getFirstNonEmptyString = (...args: Array<string | undefined>): string => args.find((arg) => !isUndefinedOrEmpty(arg)) ?? ''
